import { getSetting, LOCAL_SETTINGS_PREFIX } from './localSettings';
export function parseSettingString(value) {
  return typeof value === 'string' ? value.toLowerCase() : '';
}
export function getSettingString(key, fallback, parser, prefix = LOCAL_SETTINGS_PREFIX) {
  const value = getSetting(key, fallback, parser, prefix);
  return parseSettingString(value);
}